import { useAppSelector } from "app/hooks";
import { RoundTimeRows2 } from "../RoundTimeRows";
import {
  TrackNameHeader,
  CupModeMatchTimesTable,
  CupModeTrackTimesContainer,
  RoundNameCell,
} from "./styles";
import { TimeAttackTrack } from "model/Match/Set/TimeAttack/Track/TimeAttackTrack";
import { selectTrackNameFromTournamentId } from "selectors/Tournament";

interface Props {
  tracks: TimeAttackTrack[];
  tournamentId: string;
}

export const TimeAttackTrackTimes = ({ tracks, tournamentId }: Props) => {
  const allRounds = tracks.flatMap((track) => track.rounds);
  const maxDrivers =
    allRounds.length > 0
      ? Math.max(...allRounds.map((r) => Object.keys(r.times).length))
      : undefined;

  const borderIdxs: number[] = [0];
  tracks.forEach((t) => {
    const span = t.rounds.length;
    const lastIdx = borderIdxs.at(-1) ?? 0;
    borderIdxs.push(lastIdx + span);
  });

  return (
    <CupModeTrackTimesContainer>
      <CupModeMatchTimesTable>
        <tr>
          <th />
          {tracks.map((track) => (
            <TimeAttackMatchTimesTrackHeader
              track={track}
              tournamentId={tournamentId}
            />
          ))}
        </tr>
        <tr>
          <td />
          {allRounds.map((r, i) => (
            <RoundNameCell
              alternateBackground={i % 2 === 1}
              colSpan={2}
              leftBorder={borderIdxs.includes(i)}
            >
              {r.name ??
                `
                Round ${i + 1}`}
            </RoundNameCell>
          ))}
        </tr>
        <RoundTimeRows2
          roundTimes={allRounds.map((r) => r.times)}
          tournamentId={tournamentId}
          showPosition={true}
          maxPosition={maxDrivers ?? 0}
          padding={0}
          borderIdxs={borderIdxs}
          alternateBackground={true}
        />
      </CupModeMatchTimesTable>
    </CupModeTrackTimesContainer>
  );
};

interface TrackHeaderProps {
  track: TimeAttackTrack;
  tournamentId: string;
}

const TimeAttackMatchTimesTrackHeader = ({
  track,
  tournamentId,
}: TrackHeaderProps) => {
  const trackName = useAppSelector((state) =>
    !!track.trackId
      ? selectTrackNameFromTournamentId(state, track.trackId, tournamentId)
      : undefined
  );

  return (
    <TrackNameHeader colSpan={track.rounds.length * 2}>
      {trackName}
    </TrackNameHeader>
  );
};
